// Apariencia de un agente y de su chat web. Debe coincidir con el motor (agent-runtime/src/channels/look.ts): el motor valida y guarda;
// aquí se resuelven los mismos valores por defecto para mostrar avatares y la vista previa sin pedirlos al servidor.

export const PALETTES = {
  aurora: { name: 'Aurora', a: '#7C5CFF', b: '#2BD9FE' },
  lagoon: { name: 'Laguna', a: '#00B3A4', b: '#3D7BFF' },
  citrus: { name: 'Cítrico', a: '#FFB800', b: '#FF5E3A' },
  berry: { name: 'Mora', a: '#FF4D8D', b: '#8B5CF6' },
  mint: { name: 'Menta', a: '#22C55E', b: '#A3E635' },
  ember: { name: 'Brasa', a: '#FF6B3D', b: '#E11D48' },
};
const ORDER = Object.keys(PALETTES);

export const AVATARS = [
  { key: 'dot', label: 'Punto' },
  { key: 'square', label: 'Cuadrito' },
  { key: 'ears', label: 'Orejas' },
  { key: 'antenna', label: 'Antena' },
];
export const THEMES = [
  { key: 'auto', label: 'Automático' },
  { key: 'light', label: 'Claro' },
  { key: 'dark', label: 'Oscuro' },
];
export const POSITIONS = [
  { key: 'right', label: 'Derecha' },
  { key: 'left', label: 'Izquierda' },
];
export const LIMITS = { title: 60, greeting: 300, teaser: 120, placeholder: 80, disclaimer: 120 };
export const DEFAULT_DISCLAIMER = 'Respuestas generadas con IA. Pueden tener errores.';

/** La paleta por defecto sale del nombre: el mismo agente siempre se ve igual, aquí y en el widget. */
export function paletteFor(name = '') {
  let h = 0;
  for (const ch of String(name)) h = (Math.imul(h, 31) + ch.charCodeAt(0)) >>> 0;
  return ORDER[h % ORDER.length];
}

const lum = (hex) => {
  const [r, g, b] = [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16) / 255).map((c) => (c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4));
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};
/** Color del texto sobre el degradado: oscuro si los colores son claros. */
export const onAccent = (a, b) => ((lum(a) + lum(b)) / 2 > 0.4 ? '#14121F' : '#FFFFFF');

const clean = (v, max) => (typeof v === 'string' && v.trim() ? v.trim().slice(0, max) : undefined);

/**
 * La apariencia final. Orden: valores por defecto ← `config.web` de la versión (donde se guardaba antes) ← lo guardado en la conexión
 * (`channel_connections.external.look`). `stored` son solo los valores que el admin cambió.
 */
export function resolveLook(name, config, stored) {
  const legacy = (config && typeof config.web === 'object' && config.web) || {};
  const own = stored && typeof stored === 'object' ? stored : {};
  const pick = (k) => clean(own[k], LIMITS[k]) ?? clean(legacy[k], LIMITS[k]);
  const palette = own.colors ? 'custom' : PALETTES[own.palette] ? own.palette : PALETTES[legacy.palette] ? legacy.palette : paletteFor(name);
  const colors = own.colors || PALETTES[palette] || PALETTES.aurora;
  const greeting = pick('greeting') ?? `¡Hola! Soy ${name}. ¿En qué te ayudo?`;
  return {
    title: pick('title') ?? name,
    greeting,
    teaser: pick('teaser') ?? greeting,
    placeholder: pick('placeholder') ?? 'Escribe tu mensaje…',
    disclaimer: pick('disclaimer') ?? DEFAULT_DISCLAIMER,
    palette,
    colors: { a: colors.a ?? colors[0], b: colors.b ?? colors[1] },
    onAccent: onAccent(colors.a, colors.b),
    theme: ['light', 'dark'].includes(own.theme) ? own.theme : 'auto',
    avatar: AVATARS.some((x) => x.key === own.avatar) ? own.avatar : 'dot',
    avatarUrl: typeof own.avatarUrl === 'string' && own.avatarUrl ? own.avatarUrl : null,
    position: own.position === 'left' ? 'left' : 'right',
    follow: own.follow !== false,
  };
}

/** La apariencia de un agente tal como la cargan las pantallas (con sus conexiones y versiones). */
export function agentLookOf(agent) {
  const web = (agent?.connections || []).find((c) => c.channel === 'web');
  return resolveLook(agent?.name || '', agent?.published?.config || agent?.draft?.config, web?.external?.look);
}
